import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import {BrowserRouter} from "react-router-dom"
import './index.scss'
import './custom.scss'
import 'bootstrap-icons/font/bootstrap-icons.scss'
import {I18nextProvider} from "react-i18next"

import i18next from './i18n/config'
import {ThemeProvider} from "./context/ThemeProvider"
import {AuthProvider} from "./context/AuthProvider"

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)

root.render(
    <React.StrictMode>
        <I18nextProvider i18n={i18next}>
            <ThemeProvider>
                <BrowserRouter>
                    <AuthProvider>
                        <App/>
                    </AuthProvider>
                </BrowserRouter>
            </ThemeProvider>
        </I18nextProvider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
